import styled from "styled-components";

export const WrapperStyled = styled.div`
    position: fixed;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.65);
    overflow-y: auto;
`

